module.exports = __webpack_public_path__ + "img/earth-europa.3289ddd8.svg";